import { StoryblokServerComponent } from '@storyblok/react/rsc';
import { FC } from 'react';
import { IBannerTrust } from './types';

export const BannerTrust: FC<IBannerTrust> = ({ banner }) => {
  if (!banner) {
    return null;
  }

  return <StoryblokServerComponent blok={banner} />;
};
